module.exports = __webpack_public_path__ + "img/gili1.93c74032.jpg";